// src/components/UPIPaymentQR.jsx
import React from 'react';
import QRCode from 'react-qr-code';

export default function UPIPaymentQR({ price, orderId }) {
  // Your own UPI ID here:
  const upiId     = 'abbajumma48-1@okicici';
  const payeeName = encodeURIComponent('Hawkers Store');
  const amount    = price;
  const note      = encodeURIComponent(`Order ${orderId}`);

  const upiLink = 
    `upi://pay?pa=${upiId}` +
    `&pn=${payeeName}` +
    `&am=${amount}` +
    `&tn=${note}` +
    `&cu=INR`;

  return (
    <div className="flex flex-col items-center gap-4">
      <p>Scan to pay via UPI</p>
      <QRCode value={upiLink} size={200} />
      <p className="text-sm text-gray-600">
        Opens your UPI app for payment.
      </p>
    </div>
  );
}
